module.exports = __webpack_public_path__ + "static/media/slider-banner1.49ad1dd3.jpg";